import { defineCustomElement } from 'vue';
import TermSpan from './TermSpan.ce.vue';

export function registerElements() {
    const TermSpanElement = defineCustomElement(TermSpan);

    customElements.define('pt-term-span', TermSpanElement);
}
